export const EntityTypeUrlParam = "wiki";

export namespace CustomerIntelligenceConstants {
    export const TTIScenarioName: string = "WikiSearchTTIScenario";
    export const TabSwitchScenarioName: string = "WikiSearchTabSwitchScenario";
    export const EntityName: string = "Wiki";
    export const L2SearchBarFocused: string = "L2SearchBarFocused";
    export const SearchStarted: string = "SearchStarted";
    export const ResultsLoaded: string = "ResultsLoaded";
    export const ZeroData: string = "ZeroData";
    export const NotificationBanner: string = "NotificationBanner";
    export const SearchInNewTab: string = "SearchInNewTab";
    export const SearchTextRemoved: string = "SearchTextRemoved";
    export const AccountLinkClicked: string = "AccountLinkClicked";
    export const AccountButtonClicked: string = "AccountButtonClicked";
    export const FeedbackLinkClicked: string = "FeedbackLinkClicked";
    export const FeedbackMailLinkClicked: string = "FeedbackMailLinkClicked";
    export const FilterResetClicked: string = "FilterResetClicked";

    export const ResultLinkClicked: string = "ResultLinkClicked";
    export const ResultLinkItemIndex = "WII";
    export const UrlParameterKeyTrackingData = "tracking_data";
    export const OrgSearchNavigationFromWikiSearchPageSource = "tfs.Search.wiki";
}

export const WikiSearchTakeResults = 1000;
export const FeedbackMailToLinkFormat: string =
    "mailto:vstssearch@microsoft.com?Subject=Feedback on Azure DevOps Services Wiki Search";
export const DevOpsFeedbackMailToLinkFormat: string =
    "https://developercommunity.visualstudio.com/content/problem/post.html?space=21&version=NONE";
export const LearnMoreLink: string = "https://go.microsoft.com/fwlink/?linkid=862601";